export const mapThresholds = (
    thresholdType,
    cumulativeDegreeDays,
    generationThresholds,
    percentageThresholds,
    stageThresholds
  ) => {
    let matchedThreshold = null;
    let message = ""; 
    let indicatorMessage = ""; 
  
    switch (thresholdType) {
      case "GenerationDirect":
        for (let i = 0; i < generationThresholds.length; i++) {
          const currentThreshold = generationThresholds[i];
          const nextThreshold = generationThresholds[i + 1];
  
          if (
            cumulativeDegreeDays >= currentThreshold.cddThreshold &&
            (!nextThreshold || cumulativeDegreeDays < nextThreshold.cddThreshold)
          ) {
            matchedThreshold = currentThreshold.cddThreshold;
            message = `Pest is in the ${getOrdinal(currentThreshold.generationName)} Generation growth stage.`;
            indicatorMessage = `${getOrdinal(currentThreshold.generationName)} Generation`;
            break;
          }
        }
        break;
  
      case "GenerationPercentageDirect":
        for (let i = 0; i < generationThresholds.length; i++) {
          const generation = generationThresholds[i];
          generation.percentages.forEach((percentage) => {
            if (
              cumulativeDegreeDays >= percentage.cddThreshold &&
              (!matchedThreshold || percentage.cddThreshold > matchedThreshold) 
            ) {
              matchedThreshold = percentage.cddThreshold;
              message = `Pest has reached ${percentage.percentageValue}% of the ${getOrdinal(
                generation.generationName
              )} Generation.`;
              indicatorMessage = `${getOrdinal(generation.generationName)} Gen ${percentage.percentageValue}%`;
            }
          });
        }
        break;
  
        case "GenerationPercentageStage":
          for (let i = 0; i < generationThresholds.length; i++) {
            const generation = generationThresholds[i];
            generation.percentages.forEach((percentage) => {
              percentage.developmentStages.forEach((stage) => {
                if (
                  cumulativeDegreeDays >= stage.cddThreshold &&
                  (!matchedThreshold || stage.cddThreshold > matchedThreshold)
                ) {
                  matchedThreshold = stage.cddThreshold;
                  message = `Pest is in the ${stage.stageName} stage, at ${percentage.percentageValue}% of the ${getOrdinal(
                    generation.generationName
                  )} Generation.`;
                  indicatorMessage = `${getOrdinal(generation.generationName)} Gen ${percentage.percentageValue}% - ${stage.stageName}`;
                }
              });
            });
          }
          break;

          case "GenerationStage":
            for (let i = 0; i < generationThresholds.length; i++) {
              const generation = generationThresholds[i];
              generation.developmentStages.forEach((stage) => {
                if (
                  cumulativeDegreeDays >= stage.cddThreshold &&
                  (!matchedThreshold || stage.cddThreshold > matchedThreshold)
                ) {
                  matchedThreshold = stage.cddThreshold;
                  message = `Pest is in the ${stage.stageName} stage of the ${getOrdinal(
                    generation.generationName
                  )} Generation.`;
                  indicatorMessage = `${getOrdinal(generation.generationName)} Gen - ${stage.stageName}`;
                }
              });
            }
            break;
        
  
          case "PercentageDirect":
            percentageThresholds.forEach((percentage) => {
              if (
                cumulativeDegreeDays >= percentage.cddThreshold &&
                (!matchedThreshold || percentage.cddThreshold > matchedThreshold) // Ensure latest percentage is selected
              ) {
                matchedThreshold = percentage.cddThreshold;
                message = `Pest has achieved ${percentage.percentageValue}% progress.`;
                indicatorMessage = `${percentage.percentageValue}%`;
              }
            });
            break;
          
  
        case "PercentageStage":
          percentageThresholds.forEach((percentage) => {
            percentage.developmentStages.forEach((stage) => {
              if (
                cumulativeDegreeDays >= stage.cddThreshold &&
                (!matchedThreshold || stage.cddThreshold > matchedThreshold) // Ensure latest stage is selected
              ) {
                matchedThreshold = stage.cddThreshold;
                message = `Pest is in the ${stage.stageName} stage, at ${percentage.percentageValue}% progress.`;
                indicatorMessage = `${percentage.percentageValue}% - ${stage.stageName}`;
              }
            });
          });
          break;
            
      case "Stage":
        stageThresholds.forEach((stage) => {
          if (
            cumulativeDegreeDays >= stage.cddThreshold &&
            (!matchedThreshold || stage.cddThreshold > matchedThreshold) // Ensure latest stage is selected
          ) {
            matchedThreshold = stage.cddThreshold;
            message = `Pest is in the ${stage.stageName} growth stage.`;
            indicatorMessage = `${stage.stageName}`;
          }
        });
        break;
          
  
      default:
        break;
    }
  
    if (!matchedThreshold) {
      return { message: "No threshold crossed", value: null, indicatorMessage: "" };
    }
  
    return { message, value: matchedThreshold, indicatorMessage };
  };
  
  const getOrdinal = (number) => {
    if (!number) return number;
    const suffixes = ["th", "st", "nd", "rd"];
    const v = number % 100;
    return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  };
  

  
export  const convertToKebabCase = (input) => {
    if(typeof input !== 'string') {
      return '';
  }

  return input.trim().toLowerCase().replace(
    /\s+/g, '-'
  )

}